import { useAuth, useUser } from '@myosh/myosh-login';
import { AboutInfoModal } from '@myosh/odin-components';
import { memo } from 'react';
import { useGetEnvironmentQuery } from '@/api/generated/restV4-api';

interface AboutModalProps {
  open: boolean;
  onClose: () => void;
}

const AboutModal = ({ open, onClose }: AboutModalProps) => {
  const { data: schemaInfo } = useGetEnvironmentQuery();
  const { logout } = useAuth();

  const { state: userState } = useUser();
  const isControllingSuperuser = Boolean(userState.user?.superuser === 'true' && userState.user.controlledUsername);

  const handleLogOut = () => {
    void logout();
    localStorage.clear();
  };

  return (
    <AboutInfoModal
      data-cy="about-info-modal"
      shouldCheckZIndex
      isAboutInfoOpen={open}
      onClose={onClose}
      showLogoutButton={true}
      onLogout={handleLogOut}
      {...schemaInfo}
      version={import.meta.env.VITE_APP_VERSION as string}
      schemaTimeZone={schemaInfo?.['time-zone']}
      currentSchema={{ text: schemaInfo?.schema ?? 'n/a' }}
      controllingSuperuser={isControllingSuperuser ? userState.user?.preferred_username : undefined}
      showUserTimeZone
    />
  );
};

export default memo(AboutModal);
